export const goToUrl = (history: any, url: string, state?: any) => {
  history.push({
    pathname: url,
    search: history.location.search,
    state
  })
}

export const replaceToUrl = (history: any, url: string, state?: any) => {
  history.replace({
    pathname: url,
    search: history.location.search,
    state
  })
}
